import React from 'react';
import { useTranslation } from 'react-i18next';
import EmbeddedApp from 'components/embedded-app';
import { MARKETING_URL } from '../admin-section/marketing';

/**
 * Strategy: the artist-facing page of the marketing app (`?view=strategy`).
 * Members see the approved plan of each deal they belong to; admins pick any
 * deal from the roster search. `#deal=<dealId>` (approve mail) opens that deal.
 */
const StrategySection: React.FC = () => {
  const { t } = useTranslation();
  const url = `${MARKETING_URL}${MARKETING_URL.includes('?') ? '&' : '?'}view=strategy`;
  return <EmbeddedApp title={t('Strategy')} url={url} auth />;
};

export default StrategySection;
